import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const triangleCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default triangleCommands;
